const refreshUser = (data) => {
    return {
        type: "REFRESH",
        data: data
    }
}



export { refreshUser };